import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { getSession } from '@jbrowse/core/util';
import Base1DView from '@jbrowse/core/util/Base1DViewModel';
import { useTheme } from '@mui/material';
// locals
import { HEADER_OVERVIEW_HEIGHT } from '..';
import Cytobands from '../components/Cytobands';
import { Polygon } from '../components/OverviewScalebar';
import SVGRuler from './SVGRuler';
import SVGScalebar from './SVGScalebar';
export default function SVGHeader(_ref) {
  var model = _ref.model,
    fontSize = _ref.fontSize,
    cytobandHeight = _ref.cytobandHeight,
    rulerHeight = _ref.rulerHeight;
  var width = model.width,
    assemblyNames = model.assemblyNames,
    showCytobands = model.showCytobands,
    displayedRegions = model.displayedRegions;
  var _getSession = getSession(model),
    assemblyManager = _getSession.assemblyManager;
  var assemblyName = assemblyNames.length > 1 ? '' : assemblyNames[0];
  var assembly = assemblyManager.get(assemblyName);
  var theme = useTheme();
  var overview = Base1DView.create({
    displayedRegions: JSON.parse(JSON.stringify(displayedRegions)),
    interRegionPaddingWidth: 0,
    minimumBlockWidth: model.minimumBlockWidth
  });
  var visibleRegions = model.dynamicBlocks.contentBlocks;
  overview.setVolatileWidth(width);
  overview.showAllRegions();
  var block = overview.dynamicBlocks.contentBlocks[0];
  var first = visibleRegions[0];
  var firstOverviewPx = overview.bpToPx(_objectSpread({}, first, {
    coord: first.reversed ? first.end : first.start
  })) || 0;
  var last = visibleRegions[visibleRegions.length - 1];
  var lastOverviewPx = overview.bpToPx(_objectSpread({}, last, {
    coord: last.reversed ? last.start : last.end
  })) || 0;
  var c = +showCytobands * cytobandHeight;
  return React.createElement("g", {
    id: "header"
  }, React.createElement("text", {
    x: 0,
    y: fontSize,
    fontSize: fontSize,
    fill: theme.palette.text.primary
  }, assemblyName), showCytobands ? React.createElement("g", {
    transform: "translate(0 ".concat(rulerHeight, ")")
  }, React.createElement(Cytobands, {
    overview: overview,
    assembly: assembly,
    block: block
  }), React.createElement("rect", {
    stroke: "red",
    fill: "rgb(255,0,0,0.1)",
    width: Math.max(lastOverviewPx - firstOverviewPx, 0.5),
    height: HEADER_OVERVIEW_HEIGHT - 1,
    x: firstOverviewPx,
    y: 0.5
  }), React.createElement("g", {
    transform: "translate(0,".concat(HEADER_OVERVIEW_HEIGHT, ")")
  }, React.createElement(Polygon, {
    overview: overview,
    model: model,
    useOffset: false
  }))) : null, React.createElement("g", {
    transform: "translate(0 ".concat(fontSize + c, ")")
  }, React.createElement(SVGScalebar, {
    model: model,
    fontSize: fontSize
  })), React.createElement("g", {
    transform: "translate(0 ".concat(rulerHeight + c, ")")
  }, React.createElement(SVGRuler, {
    model: model,
    fontSize: fontSize
  })));
}